<template lang="pug">
section.content-list
  h3.title( v-if='title' ) {{ title }}
  template( v-if='contents.length > 0' )
    ul.list-unstyled.content
      b-media(
        v-for='( item, index ) in contents'
        tag='li'
        :item='item'
        :key='index'
      )
        b-img( slot='aside' blank-color='#abc' width='64' :alt='item.alt' )
        h5.mt-0.mb-1 {{ item.title }}
        | {{ item.desc }}
    a.loadmore(
      v-if='query && more'
      href='#'
      @click.prevent='loadMore'
    ) more
  template( v-else )
    .message.empty-list nothing to show yet
    a.loadmore(
      v-if='query'
      href='#'
      @click.prevent='loadMore'
    ) refresh
</template>

<script lang="js">
// TODO: add more

export default {
  name: 'content-list',
  mixins: [],
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    contents: {
      type: Array,
      default: () => []
    },
    query: {
      type: String,
      default: ''
    },
    more: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.content-list {

}
</style>
